import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import blogs from './index';
import './Article.css';

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogs.find((b) => b.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <div className="article-page">
        <div className="article-notfound">
          <h1>Article not found</h1>
          <p>The article you are looking for does not exist or has been moved.</p>
          <Link to="/blog" className="article-back">← Back to Articles</Link>
        </div>
      </div>
    );
  }

  const Article = post.component;
  return <Article post={post} />;
}
